import { PRODUCTION_DOMAIN, DEFAULT_OG_IMAGE, SITE_NAME } from '@/utils/Const'

export { PRODUCTION_DOMAIN, DEFAULT_OG_IMAGE, SITE_NAME }

/**
 * Builds combined Open Graph and Twitter Card meta tags for vue-meta.
 * Each tag uses vmid so child components can override individual tags.
 * @param {string} title
 * @param {string} description
 * @param {string} url - Canonical page URL
 * @param {string} [image] - Image URL, defaults to site logo
 * @param {string} [type] - OG type, defaults to 'website'
 * @returns {Array<object>} vue-meta compatible meta array
 */
export function buildSocialMeta(title, description, url, image, type) {
  const resolvedImage = image || DEFAULT_OG_IMAGE
  const resolvedType = type || 'website'

  return [
    { vmid: 'og:title', property: 'og:title', content: title },
    { vmid: 'og:description', property: 'og:description', content: description },
    { vmid: 'og:image', property: 'og:image', content: resolvedImage },
    { vmid: 'og:url', property: 'og:url', content: url },
    { vmid: 'og:type', property: 'og:type', content: resolvedType },
    { vmid: 'og:site_name', property: 'og:site_name', content: SITE_NAME },
    { vmid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
    { vmid: 'twitter:title', name: 'twitter:title', content: title },
    { vmid: 'twitter:description', name: 'twitter:description', content: description },
    { vmid: 'twitter:image', name: 'twitter:image', content: resolvedImage },
  ]
}
